module.exports = __webpack_public_path__ + "c7412218d7068eef9806b9940a0e0d6a.svg";